export default __webpack_public_path__ + "static/media/a65bfda1b4f12eb464eba1cb78b497981600873654629.1fbefda2.webp";